export default {
  methods: {
    // Returns boolean authorization for a given path, e.g. isAuthorized('dashboard','index','view')
    isAuthorized (...keys) {
      if (!this.$store || !this.$store.getters || !this.$store.getters.isAuthorized) {
        return false
      }
      try {
        return this.$store.getters.isAuthorized(...keys)
      } catch (e) {
        return false
      }
    },
    // Returns the raw option value at the path (mostly useful for debugging)
    getAuthOption (...keys) {
      if (!this.$store || !this.$store.getters || !this.$store.getters.getAuthOption) {
        return undefined
      }
      try {
        return this.$store.getters.getAuthOption(...keys)
      } catch (e) {
        return undefined
      }
    }
  }
}
